import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ACTION_DATA_SERVICE, ActionDataService} from '../../../../services/action/data.service';
import {BaseCustomDialog} from '../base-custom-dialog';
import {LEADS_DATA_SERVICE, LeadsDataService} from '../../../../services/leads/leads-data.service';
import {Router} from '@angular/router';

@Component({
  selector: 'fi-delete-contact',
  templateUrl: './delete-contact.component.html',
  styleUrls: ['./delete-contact.component.scss'],
  standalone: false,
})
export class DeleteContactComponent extends BaseCustomDialog {
  leadId: number;
  errorMassage = '';

  constructor(
    public dialogRef: MatDialogRef<DeleteContactComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string },
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService,
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    private router: Router
  ) {
    super(dialogRef);

    this.leadId = dialogData?.leadId;
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  onDeleteRequest(): void {
    this.leadsDataService.deleteLead(this.leadId).subscribe(({success, error}) => {
      if (success) {
        this.closeDialog();
        this.router.navigateByUrl('/');
      } else {
        const errors = JSON.parse(JSON.stringify(error));
        this.errorMassage = errors.message;
      }
    });
  }
}
